import {Injectable} from '@angular/core';
import {AngularFireAuth} from '@angular/fire/compat/auth';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';

import {Observable, of} from 'rxjs';
import {map} from 'rxjs/operators';


import { IdTokenResult, User } from '@angular/fire/auth';
@Injectable({providedIn: 'root'})
export class UnrAuthGuard implements CanActivate {

  constructor(private firebaseAuth: AngularFireAuth,
              private router: Router) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<UrlTree | boolean> {
    return of(true);
    return this.firebaseAuth
      .user
      .pipe(
        map((user: User | null) => {
          return user === null
            ? this.router.parseUrl('/')
            : true;
        })
      );
  }
}
